import { AppConfig } from '../../api/whitelabel/whitelabel.types';
import { Async } from '../../types/data.types';
import { SetAppConfig } from './whitelabel.types';

export const setAppConfig = (appConfig: Async<AppConfig>): SetAppConfig => ({
  type: 'SET_APP_CONFIG',
  payload: appConfig,
});
